// import { IBannerMessagePayload } from "src/Common/Models/BannerMessage";
export const Actions = {
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
  ONOROFF_NOTIFICATIONS: 'ONOROFF_NOTIFICATIONS',
};

export const setNotifications = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.SET_NOTIFICATIONS,
    payload,
  });
};
export const onOrOffNotifications = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.ONOROFF_NOTIFICATIONS,
    payload,
  });
};
